interface CaptureBounds {
  left: number
  top: number
  width: number
  height: number
}

// Arrows are absolutely positioned and may extend beyond the tree's box in
// either direction. Ignore attachment/link arrows, which PNG deliberately hides.
export const getPngCaptureBounds = (node: Element): CaptureBounds => {
  const root = node.getBoundingClientRect()
  const arrows = Array.from(
    node.querySelectorAll<SVGSVGElement>('.Arrow-model-node svg')
  ).map((element) => element.getBoundingClientRect())
  const visible = arrows.filter(({ width, height }) => width > 0 && height > 0)
  const left = Math.min(root.left, ...visible.map((rect) => rect.left))
  const top = Math.min(root.top, ...visible.map((rect) => rect.top))
  const right = Math.max(root.right, ...visible.map((rect) => rect.right))
  const bottom = Math.max(root.bottom, ...visible.map((rect) => rect.bottom))

  return {
    left: left - root.left,
    top: top - root.top,
    width: right - left,
    height: bottom - top,
  }
}
